// Create Element.remove() function if not exist - for IE11
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
      if (this.parentNode) {
          this.parentNode.removeChild(this);
      }
  };
}

//Copies sass variable or hex color to clipboard
var copyColorCode = function(element) {
  var codeToCopy = element.text();
  var elementArea = document.createElement('textarea');
  elementArea.setAttribute('id', 'copycode');
  elementArea.style.position = 'fixed';
  elementArea.style.bottom = 0;
  elementArea.style.left = 0;
  document.body.appendChild(elementArea);
  document.getElementById('copycode').value = codeToCopy;
  document.getElementById('copycode').select();
  document.execCommand('Copy');
  document.getElementById('copycode').remove();
}

$('.color-block-sass, .color-block-css, .color-block-hex, .color-block-rgb').click(function() {
  var elementToCopy = $(this);
  copyColorCode(elementToCopy);
  var copiedColor = $(this).text();
  elementToCopy.html('Copied!');

  setTimeout(function() {
    elementToCopy.html(copiedColor);
  }, 2000);
});


// WEBPACK FOOTER //
// ./src/assets/fabricator/scripts/f-colors.js